export const pensionTypeLabels = new Map<string, string>([
  ['ALL_INCLUSIVE', 'Tout inclus'],
  ['BREAKFAST', 'Petit-déjeuner'],
  ['FULL_BOARD', 'Pension complète'],
  ['HALF_BOARD', 'Demi-pension'],
  ['ROOM_ONLY', 'Chambre seule'],
])
